// PATH: SaberpDeals/frontend/src/lib/catalogApi.ts
import { api } from './api';

export interface CatalogItem {
    id: number;
    code: string;
    name: string;
    category: 'License' | 'Package' | 'Service';
    billingType: 'OneTime' | 'Recurring';
    defaultPrice: number;
    currency: 'USD' | 'IQD';
    isActive: boolean;
}

export type CatalogInput = Omit<CatalogItem, 'id' | 'isActive'>;

export const catalogApi = {
    async list(): Promise<CatalogItem[]> {
        const { data } = await api.get('/api/deals/catalog');
        return data;
    },
    async create(input: CatalogInput): Promise<CatalogItem> {
        const { data } = await api.post('/api/deals/catalog', input);
        return data;
    },
    async update(id: number, input: CatalogInput): Promise<CatalogItem> {
        const { data } = await api.put(`/api/deals/catalog/${id}`, input);
        return data;
    },
    async toggle(id: number): Promise<CatalogItem> {
        const { data } = await api.post(`/api/deals/catalog/${id}/toggle`, {});
        return data;
    },
};